import { createContext, useCallback, useContext, useState } from 'react';

import noop from 'lodash/noop';

import { DialogLoader } from '../../../components/Dialog/DialogLoader';

type PostSignUpWizardContextData = {
  error?: string;
  loading?: boolean;
};

export const PostSignUpWizardContext = createContext<
  PostSignUpWizardContextData & { updateContextData: (data: Partial<PostSignUpWizardContextData>) => void }
>({
  error: undefined,
  loading: false,
  updateContextData: noop,
});

export const usePostSignUpWizardContext = () => {
  return useContext(PostSignUpWizardContext);
};

export const PostSignUpWizardProvider = ({ children }: { children: React.ReactNode }) => {
  const [contextData, setContextData] = useState<PostSignUpWizardContextData>({ loading: false });

  const updateContextData = useCallback((data: Partial<PostSignUpWizardContextData>) => {
    setContextData((prev) => ({ ...prev, ...data }));
  }, []);

  return (
    <PostSignUpWizardContext.Provider value={{ ...contextData, updateContextData }}>
      <DialogLoader isProcessing={contextData.loading} />
      {children}
    </PostSignUpWizardContext.Provider>
  );
};
